import React, {useContext, ReactNode, ReactElement} from 'react';
import {useIntl} from 'react-intl';

import {Locale, useLocale} from '../../../RootProvider/LocaleContext';
import RenderOnLocales from '../../../RenderOnLocales';
import LayoutSection from '../Layout/LayoutSection/LayoutSection';
import {LayoutBackground} from '../Layout/LayoutSection/LayoutSection.types';
import HowDoesItWorkPoints from './HowDoesItWorkPoints/HowDoesItWorkPoints';
import SectionTitleAndSubtitle from '../SectionTitleAndSubtitle/SectionTitleAndSubtitle';
import DeviceContext, {Device} from '../../../RootProvider/DeviceContext';

import productImage from '../../../images/productImage.png';
import productImageNL from '../../../images/productImageNL.png';
import {HowDoesItWorkContentItem} from './HowDoesItWorkPoints/HowDoesItWorkItem';

import DynamicLink from '../../DynamicLink/DynamicLink';
import {getPageRoute} from '../../../utils/routes/getPageRoute';
import './HowDoesItWork.scss';

interface Props {
  content: HowDoesItWorkContentItem[];
  button?: ReactNode;
  className?: string;
}

function HowDoesItWork({content, button, className}: Props): ReactElement {
  const locale = useLocale();
  const {formatMessage} = useIntl();
  const device = useContext(DeviceContext);

  return (
    <LayoutSection innerClassName={`howDoesItWork ${className}`.trim()} type={LayoutBackground.GRAY}>
      <div className="howDoesItWork__content">
        <SectionTitleAndSubtitle
          className="howDoesItWork__sectionTitle"
          title={formatMessage({id: 'homepage.howDoesItWork.title'})}
          text={formatMessage({id: 'homepage.howDoesItWork.description'})}
        />
        {/* @todo Logo goes here */}
        {button ? device !== Device.MOBILE && button : undefined}

        <RenderOnLocales
          locales={[Locale.nl]}
          FallbackComponent={
            <DynamicLink href={getPageRoute('tech.fundingCloud', locale)}>
              <img
                className="howDoesItWork__image"
                alt={formatMessage({id: 'homepage.howDoesItWork.imageAlt'})}
                src={productImage}
              />
            </DynamicLink>
          }
        >
          <img
            className="howDoesItWork__image"
            alt={formatMessage({id: 'homepage.howDoesItWork.imageAlt'})}
            src={productImageNL}
          />
        </RenderOnLocales>
      </div>
      <HowDoesItWorkPoints className="howDoesItWork__points" content={content} />
      {button ? device === Device.MOBILE && button : undefined}
    </LayoutSection>
  );
}

export default HowDoesItWork;
